import BASCont from '../../components/Finance/BAS/BASCont'
import AddContractCont from '../../components/Finance/Lender/AddContract/AddContractCont'
import LendersCont from '../../components/Finance/Lender/LendersCont'
import LendersList from '../../components/Finance/Lender/LendersList'
import NewLenderCont from '../../components/Finance/Lender/NewLender/NewLenderCont'
import ViewContractCont from '../../components/Finance/Lender/ViewContract/ViewContractCont'
import AddStatementCont from '../../components/Finance/Statements/AddStatement/AddStatementCont'
import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import TransactionsCont from '../../components/Finance/Statements/Transactions/TransactionsCont'
import StatementsCont from '../../components/Finance/Statements/StatementsCont'
import NoMatchComponent from '../../components/NoMatch'
import Dropdowns from '../../modules/Dropdowns'
import DashboardCont from '../../components/Finance/Dashboard/DashboardCont'
import ReportsCont from '../../components/Finance/Reports/ReportsCont'
import TransactionsUploadCont from '../../components/Finance/Statements/Transactions/TransactionsUpload/TransactionsUploadCont'

export default class FinanceRouter extends Component {
  constructor(props) {
    super(props)
    this.url = props.match.url
  }

  componentDidMount() {
    // cache dropdowns
    new Dropdowns({ dropdown: 'transactions', name: 'type' }).set()
    new Dropdowns({ dropdown: 'transactions', name: 'receipt' }).set()
  }

  render() {
    return (
      <Switch>
        <Route path={`${this.url}/dashboard`} component={DashboardCont} />
        <Route path={`${this.url}/reports`} component={ReportsCont} />
        <Route path={`${this.url}/transactions`} component={TransactionsCont} />
        <Route path={`${this.url}/bas`} component={BASCont} />
        <Route path={`${this.url}/statements/upload`} component={TransactionsUploadCont} />
        <Route path={`${this.url}/statements/:key/update`} component={AddStatementCont} />
        <Route path={`${this.url}/statements`} component={StatementsCont} />

        <Route path={`${this.url}/lenders/list`} component={LendersList} />

        <Route path={`${this.url}/lenders/new`} component={NewLenderCont} />

        <Route path={`${this.url}/lenders/:key/contracts/new`} component={AddContractCont} />
        <Route
          path={`${this.url}/lenders/:key/contracts/:contractKey/update`}
          component={AddContractCont}
        />
        <Route
          path={`${this.url}/lenders/:key/contracts/:contractKey/view`}
          component={ViewContractCont}
        />

        <Route path={`${this.url}/lenders/:key/`} component={LendersCont} />

        <Route component={NoMatchComponent} />
      </Switch>
    )
  }
}
